module.exports = __webpack_public_path__ + "02_mole.5f59a2ec.png";


//////////////////
// WEBPACK FOOTER
// ./src/imgs/custom/momoro/papa/layer2/02_mole.png
// module id = zyOp
// module chunks = 0